// Juego de iconos propio de UPK INNOVA: trazo de 1,6 px sobre rejilla de 20 px, esquinas redondeadas.
// Se dibujan a 16 o 20 px. Decorativos por defecto (aria-hidden); el control que los contiene lleva la etiqueta.
import type { ReactNode } from 'react';

const T: Record<string, ReactNode> = {
  // navegación y estructura
  apps: (
    <>
      <circle cx="4.5" cy="4.5" r="1.4" />
      <circle cx="10" cy="4.5" r="1.4" />
      <circle cx="15.5" cy="4.5" r="1.4" />
      <circle cx="4.5" cy="10" r="1.4" />
      <circle cx="10" cy="10" r="1.4" />
      <circle cx="15.5" cy="10" r="1.4" />
      <circle cx="4.5" cy="15.5" r="1.4" />
      <circle cx="10" cy="15.5" r="1.4" />
      <circle cx="15.5" cy="15.5" r="1.4" />
    </>
  ),
  tablero: (
    <>
      <rect x="2.5" y="3" width="4.2" height="14" rx="1.2" />
      <rect x="7.9" y="3" width="4.2" height="9" rx="1.2" />
      <rect x="13.3" y="3" width="4.2" height="11.5" rx="1.2" />
    </>
  ),
  lista: (
    <>
      <path d="M7 5h10M7 10h10M7 15h10" />
      <circle cx="3.6" cy="5" r=".9" />
      <circle cx="3.6" cy="10" r=".9" />
      <circle cx="3.6" cy="15" r=".9" />
    </>
  ),
  miTrabajo: (
    <>
      <circle cx="8" cy="6.5" r="3" />
      <path d="M2.5 16.5c.6-3 2.8-4.7 5.5-4.7 1.2 0 2.3.3 3.2.9" />
      <path d="M12.5 15l1.8 1.8 3.4-3.6" />
    </>
  ),
  aprobaciones: (
    <>
      <path d="M10 2.5l6 2.3v4.6c0 4-2.6 6.9-6 8.1-3.4-1.2-6-4.1-6-8.1V4.8z" />
      <path d="M7.2 10l2 2 3.8-4" />
    </>
  ),
  excepciones: (
    <>
      <path d="M10 3l7.5 13H2.5z" />
      <path d="M10 8.2v3.6M10 14.2v.2" />
    </>
  ),
  indicadores: (
    <>
      <path d="M3 17h14" />
      <path d="M5.5 14V9.5M10 14V5M14.5 14v-6.5" />
    </>
  ),
  catalogos: (
    <>
      <path d="M4 4.2c0-.9.7-1.7 1.7-1.7H16v12.5H5.7c-.9 0-1.7.8-1.7 1.7z" />
      <path d="M4 16.7c0 .9.7 1.3 1.7 1.3H16M7.5 6h5M7.5 9h5" />
    </>
  ),
  filtro: <path d="M3 4.5h14l-5.4 6.3V16l-3.2-1.6v-3.6z" />,
  filtroGuardado: (
    <>
      <path d="M3 4.5h14l-5.4 6.3V16l-3.2-1.6v-3.6z" />
    </>
  ),
  colapsar: (
    <>
      <rect x="2.5" y="3" width="15" height="14" rx="2" />
      <path d="M7.5 3v14M13.5 8l-2 2 2 2" />
    </>
  ),
  expandir: (
    <>
      <rect x="2.5" y="3" width="15" height="14" rx="2" />
      <path d="M7.5 3v14M11.5 8l2 2-2 2" />
    </>
  ),
  pantallaCompleta: <path d="M11.5 3.5H16.5V8.5M8.5 16.5H3.5V11.5M16.5 3.5l-5.2 5.2M3.5 16.5l5.2-5.2" />,
  // acciones
  buscar: (
    <>
      <circle cx="8.8" cy="8.8" r="5.3" />
      <path d="M12.8 12.8L17 17" />
    </>
  ),
  mas: <path d="M10 4v12M4 10h12" />,
  cerrar: <path d="M5 5l10 10M15 5L5 15" />,
  check: <path d="M4.5 10.5l3.5 3.5 7.5-8" />,
  editar: (
    <>
      <path d="M12.6 3.9l3.5 3.5-8.8 8.8-4.1.6.6-4.1z" />
      <path d="M10.8 5.7l3.5 3.5" />
    </>
  ),
  papelera: (
    <>
      <path d="M3.5 5.5h13M8 5.5V3.8h4v1.7M5.2 5.5l.8 11h8l.8-11" />
      <path d="M8.5 8.5v5M11.5 8.5v5" />
    </>
  ),
  enlace: (
    <>
      <path d="M8.6 11.4a3.2 3.2 0 004.5 0l2.6-2.6a3.2 3.2 0 00-4.5-4.5l-1 1" />
      <path d="M11.4 8.6a3.2 3.2 0 00-4.5 0l-2.6 2.6a3.2 3.2 0 004.5 4.5l1-1" />
    </>
  ),
  copiar: (
    <>
      <rect x="7" y="7" width="10" height="10" rx="1.6" />
      <path d="M13 4.6V4a1.5 1.5 0 00-1.5-1.5H4A1.5 1.5 0 002.5 4v7.5A1.5 1.5 0 004 13h.6" />
    </>
  ),
  masH: (
    <>
      <circle cx="4.5" cy="10" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="10" cy="10" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="10" r="1.3" fill="currentColor" stroke="none" />
    </>
  ),
  ojo: (
    <>
      <path d="M1.8 10S4.8 4.5 10 4.5 18.2 10 18.2 10 15.2 15.5 10 15.5 1.8 10 1.8 10z" />
      <circle cx="10" cy="10" r="2.6" />
    </>
  ),
  ojoTachado: (
    <>
      <path d="M8 4.8c.6-.2 1.3-.3 2-.3 5.2 0 8.2 5.5 8.2 5.5a14 14 0 01-2.3 3M12 15.2c-.6.2-1.3.3-2 .3-5.2 0-8.2-5.5-8.2-5.5a14 14 0 012.3-3" />
      <path d="M3 3l14 14" />
    </>
  ),
  rayo: <path d="M11 2.5L4.5 11h5l-1 6.5L15.5 9h-5z" />,
  enviar: <path d="M3 10l14-6.5L12.5 17l-2.6-5.4zM9.9 11.6L17 3.5" />,
  descargar: <path d="M10 3v10M6 9.5l4 4 4-4M3.5 16.5h13" />,
  adjunto: <path d="M15.5 9.5l-5.8 5.8a3.6 3.6 0 01-5.1-5.1l6.3-6.3a2.4 2.4 0 013.4 3.4l-6.2 6.2a1.2 1.2 0 01-1.7-1.7l5.6-5.6" />,
  firma: <path d="M3 15.5c2.2 0 3-4.5 4.6-4.5 1.4 0 .4 3.6 1.8 3.6 1.1 0 1.6-1.6 2.6-1.6.8 0 .9 1.2 1.8 1.2M12.8 3.6l2.6 2.6-6 6H6.8V9.6zM3 17.5h14" />,
  subir: <path d="M10 13.5v-10M6 7l4-4 4 4M3.5 16.5h13" />,
  salir: <path d="M12.5 3.5h2.5a1.5 1.5 0 011.5 1.5v10a1.5 1.5 0 01-1.5 1.5h-2.5M8.5 14l4-4-4-4M12.5 10H3" />,
  volver: <path d="M12.5 15l-5-5 5-5" />,
  chevronAbajo: <path d="M5.5 8l4.5 4.5L14.5 8" />,
  chevronArriba: <path d="M5.5 12L10 7.5l4.5 4.5" />,
  chevronDerecha: <path d="M8 5.5l4.5 4.5L8 14.5" />,
  chevronIzquierda: <path d="M12 5.5L7.5 10l4.5 4.5" />,
  ordenar: <path d="M6.5 3.5v13M3.5 13.5l3 3 3-3M13.5 16.5v-13M10.5 6.5l3-3 3 3" />,
  flechaArriba: <path d="M10 16V4M5.5 8.5L10 4l4.5 4.5" />,
  flechaAbajo: <path d="M10 4v12M5.5 11.5L10 16l4.5-4.5" />,
  columnas: (
    <>
      <rect x="2.5" y="3.5" width="15" height="13" rx="1.6" />
      <path d="M7.5 3.5v13M12.5 3.5v13" />
    </>
  ),
  agrupar: (
    <>
      <rect x="2.5" y="3" width="15" height="5" rx="1.3" />
      <rect x="2.5" y="12" width="15" height="5" rx="1.3" />
    </>
  ),
  carriles: (
    <>
      <path d="M2.5 6.5h15M2.5 13.5h15" />
      <rect x="2.5" y="2.5" width="15" height="15" rx="2" />
    </>
  ),
  arrastre: (
    <>
      <circle cx="7.5" cy="5" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="12.5" cy="5" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="7.5" cy="10" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="12.5" cy="10" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="7.5" cy="15" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="12.5" cy="15" r="1.1" fill="currentColor" stroke="none" />
    </>
  ),
  // objetos
  campana: (
    <>
      <path d="M5 13.5V9a5 5 0 0110 0v4.5l1.5 2h-13z" />
      <path d="M8.2 17.2a2 2 0 003.6 0" />
    </>
  ),
  ayuda: (
    <>
      <circle cx="10" cy="10" r="7.5" />
      <path d="M7.8 7.8a2.3 2.3 0 114 1.6c-.8.6-1.8 1.1-1.8 2.3M10 14.3v.2" />
    </>
  ),
  usuario: (
    <>
      <circle cx="10" cy="6.8" r="3.3" />
      <path d="M3.5 17c.7-3.2 3.3-5.2 6.5-5.2s5.8 2 6.5 5.2" />
    </>
  ),
  usuarios: (
    <>
      <circle cx="7.5" cy="7" r="2.8" />
      <path d="M2.5 16.5c.6-2.8 2.6-4.4 5-4.4s4.4 1.6 5 4.4" />
      <path d="M12.5 4.5a2.8 2.8 0 010 5.2M14.5 12.4c1.5.6 2.6 2 3 4.1" />
    </>
  ),
  etiqueta: (
    <>
      <path d="M2.8 3.8v5.4l7.9 7.9a1.4 1.4 0 002 0l4.4-4.4a1.4 1.4 0 000-2L9.2 2.8H3.8a1 1 0 00-1 1z" />
      <circle cx="6.3" cy="6.3" r="1.2" />
    </>
  ),
  calendario: (
    <>
      <rect x="2.8" y="4" width="14.4" height="13" rx="1.8" />
      <path d="M2.8 8h14.4M6.5 2.5v3M13.5 2.5v3" />
    </>
  ),
  reloj: (
    <>
      <circle cx="10" cy="10" r="7.3" />
      <path d="M10 5.8V10l2.8 1.8" />
    </>
  ),
  comentario: <path d="M3.5 4.5h13a1 1 0 011 1v8a1 1 0 01-1 1h-7l-4 3v-3h-2a1 1 0 01-1-1v-8a1 1 0 011-1z" />,
  historial: (
    <>
      <path d="M3.2 10a6.8 6.8 0 106.8-6.8c-2.4 0-4.4 1.2-5.7 3" />
      <path d="M3.5 3.5v3.2h3.2M10 6.5V10l2.5 1.6" />
    </>
  ),
  archivo: (
    <>
      <path d="M11.5 2.5H5.5A1.5 1.5 0 004 4v12a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0016 16V7z" />
      <path d="M11.5 2.5V7H16" />
    </>
  ),
  dinero: (
    <>
      <rect x="2.5" y="5" width="15" height="10" rx="1.6" />
      <circle cx="10" cy="10" r="2.2" />
      <path d="M5.5 8v4M14.5 8v4" />
    </>
  ),
  edificio: (
    <>
      <rect x="4" y="2.8" width="9" height="14.4" rx="1" />
      <path d="M13 8h3v9.2H13M7 6h3M7 9h3M7 12h3M8 17.2v-2.5h1v2.5" />
    </>
  ),
  seguir: (
    <>
      <path d="M1.8 10S4.8 4.5 10 4.5 18.2 10 18.2 10 15.2 15.5 10 15.5 1.8 10 1.8 10z" />
      <circle cx="10" cy="10" r="2.6" />
    </>
  ),
  teclado: (
    <>
      <rect x="2" y="5" width="16" height="10" rx="1.6" />
      <path d="M5 8h.5M8 8h.5M11 8h.5M14 8h.5M5 11h.5M14 11h.5M7.5 11.5h5" />
    </>
  ),
  candado: (
    <>
      <rect x="4" y="8.8" width="12" height="8.5" rx="1.6" />
      <path d="M6.8 8.8V6.3a3.2 3.2 0 016.4 0v2.5" />
    </>
  ),
  inicio: <path d="M3 9.5L10 3.5l7 6M5 8v8.5h4v-4.5h2v4.5h4V8" />,
  alerta: (
    <>
      <circle cx="10" cy="10" r="7.3" />
      <path d="M10 6v4.6M10 13.6v.2" />
    </>
  ),
  info: (
    <>
      <circle cx="10" cy="10" r="7.3" />
      <path d="M10 9v5M10 6.3v.2" />
    </>
  ),
  circulo: <circle cx="10" cy="10" r="7.3" strokeDasharray="2.6 2.4" />,
  exito: (
    <>
      <circle cx="10" cy="10" r="7.3" />
      <path d="M6.8 10.2l2.2 2.2 4.2-4.6" />
    </>
  ),
  arroba: (
    <>
      <circle cx="10" cy="10" r="3" />
      <path d="M13 10v1.3a2.2 2.2 0 004.4 0V10a7.4 7.4 0 10-3 6" />
    </>
  ),
  estrella: <path d="M10 2.8l2.2 4.6 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L2.8 8.1l5-.7z" />,
  estrellaLlena: <path d="M10 2.8l2.2 4.6 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L2.8 8.1l5-.7z" fill="currentColor" />,
  chispa: (
    <>
      <path d="M8.5 3l1.4 3.9 3.9 1.4-3.9 1.4L8.5 13.6 7.1 9.7 3.2 8.3l3.9-1.4z" />
      <path d="M15 11.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z" />
    </>
  ),
  carpeta: <path d="M2.8 5.5c0-.8.7-1.5 1.5-1.5h3.4l1.6 1.8h6.4c.8 0 1.5.7 1.5 1.5v7.4c0 .8-.7 1.5-1.5 1.5H4.3c-.8 0-1.5-.7-1.5-1.5z" />,
  diagrama: (
    <>
      <rect x="2.5" y="3" width="5" height="4" rx="1" />
      <rect x="12.5" y="3" width="5" height="4" rx="1" />
      <rect x="7.5" y="13" width="5" height="4" rx="1" />
      <path d="M5 7v2.5h10V7M10 9.5V13" />
    </>
  ),
  libro: (
    <>
      <path d="M3 4.5c2.5-1 4.8-1 7 .5 2.2-1.5 4.5-1.5 7-.5v11c-2.5-1-4.8-1-7 .5-2.2-1.5-4.5-1.5-7-.5z" />
      <path d="M10 5v11" />
    </>
  ),
  bandeja: (
    <>
      <path d="M3 11l2-6.5h10l2 6.5v4.5a1 1 0 01-1 1H4a1 1 0 01-1-1z" />
      <path d="M3 11h4l1 2h4l1-2h4" />
    </>
  ),
  buzon: (
    <>
      <path d="M3 12l2.2-7h9.6L17 12v3.5a1 1 0 01-1 1H4a1 1 0 01-1-1z" />
      <path d="M3 12h4.2l1 1.8h3.6l1-1.8H17" />
      <path d="M10 3v6M7.6 6.8L10 9.2l2.4-2.4" />
    </>
  ),
  brecha: (
    <>
      <path d="M3 10h4.5M12.5 10H17" />
      <path d="M7.5 6.5v7M12.5 6.5v7" />
    </>
  ),
  diana: (
    <>
      <circle cx="10" cy="10" r="7.3" />
      <circle cx="10" cy="10" r="4" />
      <circle cx="10" cy="10" r="1" fill="currentColor" />
    </>
  ),
  error: (
    <>
      <circle cx="10" cy="10" r="7.3" />
      <path d="M7.4 7.4l5.2 5.2M12.6 7.4l-5.2 5.2" />
    </>
  ),
  zoomMas: (
    <>
      <circle cx="8.8" cy="8.8" r="5.3" />
      <path d="M12.8 12.8L17 17M6.5 8.8h4.6M8.8 6.5v4.6" />
    </>
  ),
  zoomMenos: (
    <>
      <circle cx="8.8" cy="8.8" r="5.3" />
      <path d="M12.8 12.8L17 17M6.5 8.8h4.6" />
    </>
  ),
  ajustar: <path d="M3.5 7.5v-4h4M16.5 7.5v-4h-4M3.5 12.5v4h4M16.5 12.5v4h-4" />,
  tendenciaSube: <path d="M3 14l4.5-4.5 3 3L17 6M12.5 6H17v4.5" />,
  tendenciaBaja: <path d="M3 6l4.5 4.5 3-3L17 14M12.5 14H17V9.5" />,
  tendenciaEstable: <path d="M3 10h14M13 6.5l4 3.5-4 3.5" />,
  corazon: <path d="M10 16.5S3 12.4 3 7.6A3.6 3.6 0 0110 6a3.6 3.6 0 017 1.6c0 4.8-7 8.9-7 8.9z" />,
  pulso: <path d="M2.5 10h3.5l2-5 4 10 2-5h3.5" />,
  mapa: (
    <>
      <path d="M2.8 5l4.6-1.8 5.2 1.8 4.6-1.8v11.8l-4.6 1.8-5.2-1.8-4.6 1.8z" />
      <path d="M7.4 3.2v11.8M12.6 5v11.8" />
    </>
  ),
  regalo: (
    <>
      <rect x="3" y="7.5" width="14" height="9" rx="1.2" />
      <path d="M2.5 7.5h15M10 7.5v9M10 7.5S8.8 3.5 6.8 3.6C5 3.7 5.5 7.5 10 7.5zM10 7.5s1.2-4 3.2-3.9c1.8.1 1.3 3.9-3.2 3.9z" />
    </>
  ),
  maletin: (
    <>
      <rect x="2.8" y="6" width="14.4" height="10.5" rx="1.6" />
      <path d="M7 6V4.5c0-.6.5-1 1-1h4c.5 0 1 .4 1 1V6M2.8 10.5h14.4" />
    </>
  ),
  // tipos de caso (glifos sobre baldosa de color)
  tipoSuministro: (
    <>
      <path d="M10 3l6.5 3.5v7L10 17l-6.5-3.5v-7z" />
      <path d="M3.5 6.5L10 10l6.5-3.5M10 10v7" />
    </>
  ),
  tipoServicio: (
    <>
      <path d="M12.7 3.3a4 4 0 00-4.9 5.2l-4.6 4.6a1.6 1.6 0 002.3 2.3l4.6-4.6a4 4 0 005.2-4.9l-2.4 2.4-2.1-.5-.5-2.1z" />
    </>
  ),
  tipoProyecto: (
    <>
      <path d="M10 3l7.5 4-7.5 4-7.5-4z" />
      <path d="M2.5 10.5l7.5 4 7.5-4M2.5 14l7.5 4 7.5-4" />
    </>
  ),
  tipoLicitacion: (
    <>
      <path d="M5.5 2.5h7l3 3v12h-10z" />
      <path d="M8 9h5M8 12h5M8 15h3" />
    </>
  ),
  tipoPorClasificar: (
    <>
      <circle cx="10" cy="10" r="6.5" strokeDasharray="2.4 2.2" />
    </>
  ),
  // prioridad
  prioridadAlta: <path d="M5 11.5L10 6.5l5 5M5 15.5l5-5 5 5" />,
  prioridadMedia: <path d="M5 8h10M5 12.5h10" />,
  prioridadBaja: <path d="M5 8.5l5 5 5-5" />,
};

export type NombreIcono = keyof typeof T;

export function Icono({ nombre, tam = 16, className, titulo }: { nombre: NombreIcono | string; tam?: number; className?: string; titulo?: string }) {
  const contenido = T[nombre] ?? T.info;
  return (
    <svg
      width={tam}
      height={tam}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={tam <= 16 ? 1.7 : 1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ? `icono ${className}` : 'icono'}
      aria-hidden={titulo ? undefined : true}
      role={titulo ? 'img' : undefined}
      focusable="false"
    >
      {titulo && <title>{titulo}</title>}
      {contenido}
    </svg>
  );
}
